<app-usecases-hero [pageData]="pageData"></app-usecases-hero>
<app-common-companies-panel
  [companiesData]="companiesData"
></app-common-companies-panel>
<ng-container *ngIf="marketPlacePaymentSolutionData && isDifferentLayout">
  <app-usecases-payment-solutions-feature [marketPlacePaymentSolutionData]="marketPlacePaymentSolutionData"></app-usecases-payment-solutions-feature>
</ng-container>
<ng-container *ngIf="isDifferentLayout">
  <app-usecases-feature
    [pageData]="pageData"
  ></app-usecases-feature>
</ng-container>

<ng-container *ngIf="!isDifferentLayout">
  <app-usecases-feature
    [whitePaperData]="whitePaperData"
    [pageData]="pageData"
  ></app-usecases-feature>
</ng-container>
<ng-container *ngIf="isDifferentLayout">
  <app-usecases-other-feature [pageData]="pageData" [isInside]="true"></app-usecases-other-feature>
</ng-container>


<app-common-faq
  [faqData]="faqData"
></app-common-faq>
@if(benefitsData){
  <app-usecases-benefits
    [benefitsData]="benefitsData"
  ></app-usecases-benefits>
}
<app-common-subproducts-whitepaper
  [whitePaperData]="whitePaperData"
></app-common-subproducts-whitepaper>

<ng-container *ngIf="!isDifferentLayout">
  @if(!discoverData){
    <app-usecases-other-feature [pageData]="pageData"></app-usecases-other-feature>
  } @else {
    <app-usecases-other-feature [pageData]="pageData" [isInside]="true"></app-usecases-other-feature>
  }
</ng-container>
@if(discoverData){
  <app-common-discover-why
    [discoverData]="discoverData"
    [bgWhite]="true"
    [hideTrustPilot]="true"
  ></app-common-discover-why>
}
<app-common-getstarted
  [getStartedData]="getStartedData"
></app-common-getstarted>
